import {
  FETCH_BEGIN_CHALLENGE_TEAM_DETAIL,
  FETCH_BEGIN_CHALLENGE_TEAM_SUCCESS,
  FETCH_BEGIN_CHALLENGE_TEAM_FAILURE,
  FETCH_BEGIN_USER_DETAIL_SUCCESS,
  FETCH_BEGIN_USER_DETAIL_FAILURE
} from '../actions/types';
import { CHALLENGE } from '../common/challengeConstants';

const initialState = {
  teamData: {},
  userDetail: [],
  users: [],
  loading: false,
  error: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_BEGIN_CHALLENGE_TEAM_DETAIL:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_BEGIN_CHALLENGE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        teamData: action.payload,
        error: null,
      };
    case FETCH_BEGIN_CHALLENGE_TEAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case FETCH_BEGIN_USER_DETAIL_SUCCESS: {
      // add profile image of users, matching partyId from challenge system
      const defaultProfile = '/images/challenge/default_challenge_profile.svg';

      const userDetail = state?.teamData?.challengeUserData?.map(user => {
        const data = action?.payload?.lineUserData?.find(val => val?.partyId == user?.partyId);
        return {
          userName: user?.userName || CHALLENGE.teamDashboard.noUser,
          pictureUrl: data?.pictureUrl || defaultProfile,
          partyId: user?.partyId || '',
          aboId: user?.aboId || '',
          firstName: user?.firstName || '',
          lastName: user?.lastName || '',
          isLeader: user?.isLeader || false
        };
      });

      const updatedUsers = state?.teamData?.users?.map(user => {
        const data = action?.payload?.lineUserData?.find(val => val?.partyId == user?.partyId);
        return {
          ...user,
          pictureUrl: data?.pictureUrl || defaultProfile
        };
      });

      return {
        ...state,
        loading: false,
        userDetail: userDetail,
        teamData: {
          ...state.teamData,
          userDetail: userDetail,
          users: updatedUsers,
        },
        error: null,
      };
    }
    case FETCH_BEGIN_USER_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}